import { render, staticRenderFns } from "./end_of_trial_modal.vue?vue&type=template&id=2dda206c"
import script from "./end_of_trial_modal.vue?vue&type=script&lang=js"
export * from "./end_of_trial_modal.vue?vue&type=script&lang=js"
import style0 from "./end_of_trial_modal.vue?vue&type=style&index=0&id=2dda206c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports